import {
  CcfDoubleArrowIcon,
  CcfTypography,
  CcfAccordion,
  CcfAccordionSummary,
  CcfAccordionDetails,
  CcfTooltip,
  CcfPinControlIcon,
} from '@nice-ccf/ui-controls';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { createStyles, makeStyles } from '@mui/styles';
import { useTranslator, CcfBox } from '@nice-ccf/ui-controls';
import CheckIcon from '@mui/icons-material/Check';
import {
  Direction,
  useTheme,
  Paper,
  IconButton,
  colors,
  Link,
} from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import {
  activeContactSelector,
  getApplicationDirection,
} from '@nice-ccf/ui-components';

import styles from './ccf-current-interaction.module.scss';
import customerCardStyles from '../ccf-customer-card.styles';
import { useMsal } from '@azure/msal-react';

const useStyles = makeStyles((theme) =>
  createStyles({
    inputRoot: {
      font: 'normal normal normal 13px/30px Open Sans !important',
      letterSpacing: '0px',
      color: '#33333 !important',
      lineHeight: '18px',
      '&. MuiInputBase-root': {
        font: 'normal normal normal 13px/30px Open Sans !important',
        letterSpacing: '0px',
        webkitTextFillColor: '#333333 !important',
        lineHeight: '18px',
      },
    },
    input: {
      color: '#333333 !important',
    },
    disabled: {
      '&.Mui-disabled': {
        '-webkit-text-fill-color': '#333333 !important',
        border: 'none !important',
      },
    },
  })
);

/* eslint-disable-next-line */
export interface CcfCurrentInteractionProps {}

/**
 * CcfCurrentInteraction used to disply current  customer details in the AppSpace
 * @param props --? - CcfCurrentInteractionProps
 * @example -- <CcfCurrentInteraction />
 */
export function CcfCurrentInteraction(props: CcfCurrentInteractionProps) {
  const appDirection: Direction = useSelector(getApplicationDirection);
  const activeContact = useSelector(activeContactSelector);
  const interaction = activeContact?.recentInteraction;
  const {  accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || " ";
  const loginCredentialsArray = loginCredentialsFromSSO?.split(" ");
  const agentFirstName = loginCredentialsArray[0].charAt(0).toUpperCase() + loginCredentialsArray[0].slice(1).toLowerCase();
  const agentSurName = loginCredentialsArray[1].charAt(0).toUpperCase() + loginCredentialsArray[1].slice(1).toLowerCase();
  const [expanded, setExpanded] = useState('currentinteraction');
  const theme = useTheme();
  const stylesAccordion = customerCardStyles(theme);

  const ltrRtlActive = appDirection === 'rtl' ? 'rtlActive' : 'ltrActive';

  /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange = (panel: string) => {
    setExpanded(expanded === 'currentinteraction' ? '' : panel);
  };
  const [translate] = useTranslator();

  return (
    <section className={ltrRtlActive}>
      <CcfAccordion
        square
        expanded={expanded === 'currentinteraction'}
        // onChange={() => handleChange('currentinteraction')}
        sx={stylesAccordion.accordionContainer}
      >
        <CcfAccordionSummary
          expandIcon={
            <CcfDoubleArrowIcon
              onClick={() => handleChange('currentinteraction')}
              sx={stylesAccordion.expandedIcon}
            />
          }
          aria-controls="current-interaction-header"
          sx={
            expanded === 'currentinteraction'
              ? stylesAccordion.accordionHeaderExpand
              : stylesAccordion.ccfAppSpaceAccordionHeader
          }
          id="agent_appSpace_currentInteraction"
        >
          <CcfBox className={styles.contactChannelInfo}>
            <CcfBox component="div" className={styles.titleRow}>
              <CcfTypography className={styles.title}>
                {' '}
                Current Interaction
              </CcfTypography>
              {expanded === 'currentinteraction' && (
                <CcfTooltip
                  title={'Refresh CRM records'}
                  arrow
                  placement="top"
                  styles={{
                    ccfTooltipArrow: {
                      color: 'white',
                    },
                    ccfTooltip: {
                      borderRadius: '6px',
                      backgroundColor: 'white',
                      boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                      color: 'black',
                    },
                  }}
                >
                  <IconButton
                    style={{
                      backgroundColor: 'var(--color-blue)',
                      borderRadius: '3px',
                      padding: '0px 11px',
                    }}
                    id={`agent_appSpace_currentInteraction_refresh`}
                  >
                    <CcfTypography style={{ color: '#ffffff' }}>
                      Refresh
                    </CcfTypography>
                  </IconButton>
                </CcfTooltip>
              )}
            </CcfBox>
          </CcfBox>
        </CcfAccordionSummary>
        <CcfAccordionDetails>
          <section className={styles.interactionContainer}>
            <Paper style={{ padding: '10px 15px', width: 'auto' }}>
              <div className={styles.paperParent}>
                <div
                  style={{ display: 'flex', gap: '5px', alignItems: 'center' }}
                >
                  <PushPinIcon className={styles.pinIconStyle} />
                  <CcfTypography style={{ fontWeight: '600', minWidth: '20%' }}>
                    ID : c9c54078...
                  </CcfTypography>{' '}
                </div>
                <div style={{ display: 'flex' }}>
                  <CcfBox className={styles.greenStatus}>
                    <CheckIcon className={styles.tickIcon} />
                  </CcfBox>
                  <div style={{ height: '25px' }}>
                    <CcfTooltip
                      title="ServiceNow 2 Contact"
                      arrow
                      placement="top"
                      styles={{
                        ccfTooltipArrow: {
                          color: 'white',
                        },
                        ccfTooltip: {
                          borderRadius: '6px',
                          backgroundColor: 'white',
                          boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                          color: 'black',
                        },
                      }}
                    >
                      <div>
                        <Link
                          href={interaction[0].crmUrl}
                          underline="none"
                          className={styles.viewCRmLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={interaction[0].crmIcon}
                            style={{ width: '70px', height: '25px' }}
                            alt={'nowCase'}
                          />
                        </Link>
                      </div>
                    </CcfTooltip>
                  </div>
                </div>
              </div>
              <div>
                <div className={styles.statusGrid}>
                  <CcfTypography style={{ width: 'auto' }}>
                    Priority : N/A
                  </CcfTypography>
                  <CcfTypography style={{ color: 'rgb(80, 201, 80)' }}>
                    In Progress
                  </CcfTypography>
                </div>
                <CcfTypography>Assigned to : {agentFirstName +" " + agentSurName}</CcfTypography>
              </div>
            </Paper>
          </section>
        </CcfAccordionDetails>
      </CcfAccordion>
    </section>
  );
}

export default CcfCurrentInteraction;
